import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Fallback labels if i18n isn't initialized for some reason (or a caller
// passed a sentinel `t` that doesn't have these keys).
const FALLBACK = {
  "page.not_found": "Page not found",
  "page.home": "Homepage",
  "page.support": "Contact support",
};

// `t` is accepted as a prop for backwards compatibility with older callers,
// but it's optional — the component pulls its own translator if it's missing
// or not callable. This keeps the component safe to render anywhere.
const NotFound = ({ t: tProp }) => {
  const [tHook] = useTranslation("common");
  const t = (key) => {
    try {
      const fn = typeof tProp === "function" ? tProp : tHook;
      const out = fn(key);
      return out && out !== key ? out : FALLBACK[key] || key;
    } catch {
      return FALLBACK[key] || key;
    }
  };

  return (
    <div
      className='d-flex flex-column justify-content-center align-items-center'
      style={{ height: "100vh" }}
    >
      <div style={{ padding: "40px 15px", textAlign: "center" }}>
        <div className='d-flex justify-content-center align-items-center'>
          <span
            style={{
              marginRight: "5px",
              borderRight: "1px solid black",
              paddingRight: "7px",
              fontSize: "24px",
            }}
          >
            404
          </span>
          <span>{t("page.not_found")}</span>
        </div>
        <div className='my-5'>
          <Link
            to='/'
            className='btn btn-primary my-2 d-flex justify-content-center align-items-center'
          >
            <i className='bx bx-md bxs-home'></i>
            {t("page.home")}
          </Link>
          <Link
            to='/contact'
            className='btn btn-info my-2 d-flex justify-content-center align-items-center'
          >
            <i className='bx bx-md bxs-envelope'></i> {t("page.support")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
